// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-screen-14 .tab-info-campaign {\n  opacity: 0;\n  visibility: hidden;\n}\n.custom-screen-14 .nav-item {\n  width: 280px;\n}", ""]);
// Exports
module.exports = exports;
